import { Button, Form, Input, Select } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { jcTypeArray } from "../../utils";

import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import ImageUploader from "../FileManager/upload";

const AddMerchant = ({ visibleData, onCloseMethod }: any) => {
  const [generatedImgUrl, setGeneratedImgUrl] = useState<string>();
  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [merchantData, setmerchantData] = useState(undefined);
  const [merchantUrl, setMerchantUrl] = useState(undefined);
  const [error, setError] = useState("");

  const onSubmit = useCallback(
    async (data) => {
      if (generatedImgUrl) {
        setLoading(true);

        const readyData = data && {
          type: data.type,
          name: data.name,
          email: data.email,
          mobileNumber: `+88${data?.mobileNumber}`,
          // password: data.password,
          image: generatedImgUrl ? generatedImgUrl : data?.image,
        };

        if (merchantData) {
          await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/merchant`, {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              ...readyData,
              id: merchantData?.id,
              deleted: false,
            }),
          })
            .then((res) => res.json())
            .then((res) => {
              setLoading(false);

              if (res.statusCode === 200) {
                responseNotification(
                  "Merchant Updated Successfully",
                  "success"
                );
                form.resetFields();
                if (onCloseMethod) {
                  onCloseMethod();
                }
              } else if (res.status === 500) {
                responseNotification("Internal server error", "error");
              } else {
                responseNotification(
                  res.message || "something wrong",
                  "warning"
                );
              }
            })
            .catch((err) => {
              setLoading(false);
              responseNotification(
                `${"Internal server error"} ${err}`,
                "error"
              );
              console.error("err", err);
            });
        } else {
          await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/merchant`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(readyData),
          })
            .then((res) => res.json())
            .then((res) => {
              setLoading(false);

              if (res.statusCode === 200) {
                responseNotification("Merchant Create Successfully", "success");
                form.resetFields();
                if (onCloseMethod) {
                  onCloseMethod();
                }
              } else if (res.status === 500) {
                responseNotification("Internal server error", "error");
              } else {
                responseNotification(
                  res.message || "something wrong",
                  "warning"
                );
              }
            })
            .catch((err) => {
              setLoading(false);
              responseNotification(
                `${"Internal server error"} ${err}`,
                "error"
              );
              console.error("err", err);
            });
        }
      } else {
        responseNotification(`Image required`, "error");
      }
    },
    [generatedImgUrl]
  );

  useEffect(() => {
    if (visibleData) {
      setmerchantData(visibleData);
      setGeneratedImgUrl(visibleData?.image);
    }
  }, [visibleData]);

  useEffect(() => {
    if (merchantData) {
      form.resetFields(Object.keys(visibleData));
      setMerchantUrl(visibleData?.image);
    }
  }, [merchantData]);

  useEffect(() => {
    if (startUpload === "Uploaded") {
      form.submit();
    }
  }, [startUpload]);

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          initialValues={{
            ...merchantData,
            type: merchantData?.type,
            mobileNumber: merchantData?.mobileNumber?.replace("+88", ""),
          }}
        >
          <Form.Item
            hasFeedback
            label="Type"
            rules={[
              {
                required: true,
                message: "Type is required!",
              },
            ]}
            name="type"
          >
            <Select placeholder="Shop Type">
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Select.Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            hasFeedback
            label="Merchant Name"
            rules={[
              {
                required: true,
                message: "Name is Required!",
              },
            ]}
            name="name"
          >
            <Input id="name" type="text" placeholder="Enter Merchant Name" />
          </Form.Item>
          <Form.Item
            hasFeedback
            label="Email"
            rules={[
              {
                required: true,
                message: "Email is required!",
              },
              // { type: 'string', max: 11, min: 11 },
              {
                validator: async (_, email) => {
                  if (
                    email &&
                    !String(email)
                      .toLowerCase()
                      ?.match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                      )
                  ) {
                    return Promise.reject(new Error("Enter valid email"));
                  }
                },
              },
            ]}
            name="email"
          >
            <Input
              id="email"
              type="email"
              placeholder="Enter Email"
              // addonAfter={"@gmail.com"}
            />
          </Form.Item>
          <Form.Item
            hasFeedback
            label="Mobile Number (Merchant's)"
            rules={[
              {
                required: true,
                message: "Mobile Number is required!",
              },
              {
                validator: async (_, names) => {
                  if (!names?.match(/(^(01){1}[3456789]{1}(\d){8})$/)) {
                    return Promise.reject(
                      new Error("Enter valid mobile number")
                    );
                  }
                },
              },
            ]}
            name="mobileNumber"
            initialValue={"01"}
          >
            <Input
              disabled={merchantData?.data}
              id="mobileNumber"
              type="contact"
              addonBefore={"+88"}
              placeholder="Enter Mobile Number"
            />
          </Form.Item>
          {/* <Form.Item
            hasFeedback
            label="Password"
            rules={[
              {
                required: true,
                message: "Password is Required!",
              },
            ]}
            name="password"
          >
            <Input id="password" type="password" placeholder="Enter Password" />
          </Form.Item> */}
          <h4 className="title" style={{ maxWidth: "99%" }}>
            Image:
          </h4>
          <div className="">
            <ImageUploader
              imgUrl={generatedImgUrl || ""}
              startUpload={startUpload}
              setStartUpload={(val: any) => setStartUpload(val)}
              setGeneratedImgUrl={(url: any) => setGeneratedImgUrl(url)}
            />
          </div>
          <div className="buttons-container">
            <Button
              disabled={loading || !!error}
              loading={(loading ? "loading" : undefined) as any}
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
              onClick={(e) => {
                e.preventDefault();
                setStartUpload("Uploading");
              }}
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={() => {
                form?.resetFields();
                setMerchantUrl(undefined);
                setGeneratedImgUrl(undefined);
                setStartUpload(undefined);
              }}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddMerchant;
